import { render, staticRenderFns } from "./panel-expired.vue?vue&type=template&id=72f703fc&scoped=true&"
import script from "./panel-expired.vue?vue&type=script&lang=js&"
export * from "./panel-expired.vue?vue&type=script&lang=js&"
import style0 from "./panel-expired.vue?vue&type=style&index=0&id=72f703fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f703fc",
  null
  
)

export default component.exports